function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 13H31L31 22H28V25H31C32.6569 25 34 23.6569 34 22V13C34 11.3431 32.6569 10 31 10H22C20.3431 10 19 11.3431 19 13V16H22V13ZM16 19V22H13V31H22V28H25V31C25 32.6569 23.6569 34 22 34H13C11.3431 34 10 32.6569 10 31V22C10 20.3431 11.3431 19 13 19H16Z",
  fill: "currentcolor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25 20C25 19.4477 24.5523 19 24 19H20C19.4477 19 19 19.4477 19 20V24C19 24.5523 19.4477 25 20 25H24C24.5523 25 25 24.5523 25 24V20Z",
  fill: "currentcolor"
});

var SvgMerge = function SvgMerge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMerge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/merge.24067ba2.svg";
export { ForwardRef as ReactComponent };